
import { Page } from '@/src/ui-components';
import { PricePairOraclesList } from './components';

export default function OraclesPage() {
  return (
    <Page>
      <Page.Body>
        <PricePairOraclesList />
      </Page.Body>
    </Page>
  );
}
